import { render, staticRenderFns } from "./FullPageDigiCourseBuilder.vue?vue&type=template&id=79e2a068&"
import script from "./FullPageDigiCourseBuilder.vue?vue&type=script&lang=js&"
export * from "./FullPageDigiCourseBuilder.vue?vue&type=script&lang=js&"
import style0 from "./FullPageDigiCourseBuilder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports